export const styles = theme => ({
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    topMargin: {
        marginTop: theme.spacing(2)
    },
});